/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  dialog: {
    '& .MuiDialog-paperFullScreen': {
      overflowY: 'visible',
      padding: Tokens.spacing['$sp-4']
    }
  },
  header: {
    paddingLeft: theme.spacing(2),
  },
  switchSection: {
    display: 'flex',
    alignItems: 'center'
  },
  searchResetSection: {
    marginRight: Tokens.spacing['$sp-4'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& hr': {
      margin: theme.spacing(0, 2),
    },
    '& .MuiButtonBase-root': {
      marginLeft: Tokens.spacing['$sp-1']
    }
  },
  searchSection: {
    display: 'flex',
    alignItems: 'center',
    
  },
  searchComponent: {
    display: 'flex',
    alignItems: 'center'
  },
  searchButton: {
    marginLeft: '5px'
  },
  conjuction: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    padding: theme.spacing(0, 1),
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center'
  },
  saveButton: {
    margin: theme.spacing(0, 1.5)
  },
  userListWrap: {
    height: "100%",
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1.5, 2),
    borderTop: '1 px solid rgba(235, 235, 235, 1)'
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0, 1),
    padding: Tokens.spacing['$sp-1-5'],
    borderRadius: Tokens.spacing['$sp-1-25'],
    color: theme.palette.text.primary,
  },
  warningIcon: {
    marginRight: 10,
  },
  toolbarPanel: {
    padding: Tokens.spacing['$sp-3']
  },
}));
